import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} comprehensive volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} strategic bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="bg-stage-deep energy-glow tech-grid relative isolate overflow-hidden" data-id="element-103" data-mp="saruar6c52ch">
      <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-104" data-mp="ncq1hej3xont" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-105" data-mp="neazje4mrpqf">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-md border border-green/50 bg-green/15 px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-greenGlow" data-id="element-106" data-mp="3czfl7z4xc761">
          <ZapIcon className="h-4 w-4" aria-hidden="true" data-id="element-107" data-mp="39b4gcyqfxq1v" /> Renewable Energy Complete Collection
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.05] text-white sm:text-5xl lg:text-6xl" data-id="element-108" data-mp="3e84orgarj4w5">
          Master your year of renewable energy teaching
          <br data-id="element-109" data-mp="2vi54r7ts4fzl" />
          <span className="text-yellow" data-id="element-110" data-mp="2vjpyiv89ruwe">in one afternoon.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-111" data-mp="2hix2g62bkrr6">
          <img src={productImage} alt="Renewable Energy Complete Collection: nine volumes and five bonus resources covering solar, wind, hydropower, biomass, geothermal and energy storage" className="mx-auto w-full rounded-xl drop-shadow-[0_24px_44px_rgba(2,10,25,.6)]" data-id="element-112" data-mp="s44itpsj1piy" />
        </motion.div>

        <div className="mt-9" data-id="element-113" data-mp="1b1fe6zb1fyt4">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-114" data-mp="1azkqjd8dtslc">
            Get your collection now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-onDark" data-id="element-115" data-mp="112pzffefuuh3">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-md border border-steel bg-navy/70 px-3 py-2" data-id="element-116" data-mp="x0l4mdc97rsv">
              <Icon className="h-3.5 w-3.5 text-greenGlow" aria-hidden="true" data-id="element-117" data-mp="3hr3sjxze2f6v" />
              {label}
            </li>)}
        </ul>

        <p className="mt-6 text-xs font-semibold uppercase tracking-[.14em] text-mutedDark" data-id="element-118" data-mp="1xb5ped03cpfl">
          Created by specialists, for educators worldwide · Updated 2026
        </p>
      </div>
    </section>;
}